<mat-form-field appearance="outline" class="w-100 m-t-5" [ngClass]="allClasses">
  <input matInput [min]="minVal" [type]="type" [placeholder]="placeholder" [formControl]="control" [readonly]="readonly" />

</mat-form-field>
<div class="error">
  <app-error [control]="control" [type]="type"></app-error>
</div>
